module.exports = __webpack_public_path__ + "static/img/wuE.1a173c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/wuE.png
// module id = +hBA
// module chunks = 1